import { appendAssistantTextMessage } from "@/components/assistant/appendAssistantTextMessage";
import { trailingAssistantMessageHasText } from "@/components/assistant/assistantMessageText";
import {
  writeApprovalSuccessMessageText,
  type WriteApprovalEntityKind,
} from "@/components/assistant/formatWriteApprovalSummary";
import type { UIMessage } from "ai";

export function applyWriteApprovalSuccessMessageIfNeeded({
  kind,
  mode,
  messages,
  setMessages,
  displayName,
}: {
  kind: WriteApprovalEntityKind;
  mode: "create" | "update";
  messages: UIMessage[];
  setMessages: (messages: UIMessage[]) => void;
  displayName: string;
}): UIMessage[] {
  if (trailingAssistantMessageHasText(messages)) return messages;
  const name = displayName.trim();
  if (!name) return messages;
  const next = appendAssistantTextMessage(
    messages,
    writeApprovalSuccessMessageText(kind, mode, name)
  );
  setMessages(next);
  return next;
}
